// LanguageValuePair.js
export default class LanguageValue {
  constructor(language = "", value = "") {
    this.language = language; // String
    this.value = value; // String
  }

  // Getter for value
  getValue() {
    return this.value;
  }

  // Getter for language
  getLanguage() {
    return this.language;
  }

  // Setter for value
  setValue(newValue) {
    this.value = newValue;
  }

  // Setter for language
  setLanguage(newLanguage) {
    this.language = newLanguage;
  }

  // Convert to JSON-like object
  toJSON() {
    return {
      language: this.language,
      value: this.value,
    };
  }
}
